import { TabOption } from 'lib/components/Tabs';

export type InvoicesTabId = 'customer-invoices-tab' | 'publisher-invoices-tab';

export const CUSTOMER_INVOICES_TAB: TabOption<InvoicesTabId> = {
  label: 'Customer Invoices',
  enabled: true,
  id: 'customer-invoices-tab'
};

export const PUBLISHER_INVOICES_TAB: TabOption<InvoicesTabId> = {
  label: 'Publisher Invoices',
  enabled: true,
  id: 'publisher-invoices-tab'
};

export const INVOICES_TABS: TabOption<InvoicesTabId>[] = [
  CUSTOMER_INVOICES_TAB,
  PUBLISHER_INVOICES_TAB
];

export const INVOICES_TAB_QUERY_PARAM = 'tab';

export const getInvoicesTabById = (
  id: string | null
): TabOption<InvoicesTabId> | undefined =>
  INVOICES_TABS.find(tab => tab.id === id);
